import API from "serviceshift-ui/api-client";

export default {
  fetchReportGroups() {
    return API.makeRequest("/reports/all.json", {
      method: "GET",
    });
  },
  submitDatatableSelections(_, { link, data }) {
    return API.makeRequest(link, {
      method: "POST",
      data,
    });
  },
};
